import {createModelSchema, alias} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";


export class SmartOfferBundleTreasureAchievement extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.TREASURE_ACHIEVEMENT);

        this._rewardTrack = null;
    }

    get rewardTrack() {
        return this._rewardTrack;
    }

    set rewardTrack(value) {
        this._rewardTrack = value;
    }

    valid() {

        if (this.rewardTrack && !this.rewardTrack.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.rewardTrack || this.rewardTrack.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTreasureAchievement());
        } else if (target instanceof SmartOfferBundleTreasureAchievement) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTreasureAchievement, {
    _rewardTrack: alias("reward_track", RewardTrack.schema())
});
